import { UserModel, AddUserModel } from './../../models/user.model';

export class FilterUsers {
  static readonly type = '[Management-State] Filter Users';
  constructor() {}
}

export class AddUser {
  static readonly type = '[Management-State] Add User';
  constructor(public model: AddUserModel) {}
}

export class EditUser {
  static readonly type = '[Management-State] Edit User';
  constructor(public model: UserModel) {}
}

export class RemoveUser {
  static readonly type = '[Management-State] Remove User';
  constructor(public modelId: string) {}
}

export class ImportUsers {
  static readonly type = '[Management-State] Import Users';
  constructor(public data: string) {}
}
